import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
 // { path: '', loadChildren: './pages/tab-test/tabs/tabs.module#TabsPageModule' },
 // { path: '', outlet: 'outlet-home', loadChildren: './pages/mypage/main.module#MyPageMainModule'},
 // { path: 'mypage', loadChildren: './pages/mypage/main.module#MyPageMainModule'},
 // { path: 'mypage', outlet: 'outlet-home', redirectTo: '/mypage/(outlet-home:mypage)'},
 { path: '', loadChildren: './pages/main/main.module#HomePageModule'},
  { path: 'intro', loadChildren: './pages/intro/intro.module#IntroModule'},
  { path: 'auth', loadChildren: './pages/auth/auth.module#AuthModule'},
 { path: 'market', loadChildren: './pages/market/market.module#MarketPageModule'},
 { path: 'fight', loadChildren: './pages/fight/fight.module#FightPageModule'},
 { path: 'bbs', loadChildren: './pages/bbs/bbs.module#BbsModule'},
 { path: 'mypage', loadChildren: './pages/mypage/main.module#MyPageMainModule'},
 { path: 'games', loadChildren: './pages/games/games.module#GamesModule'},
 { path: 'customercenter', loadChildren: './pages/customercenter/customercenter.module#CustomercenterModule'},

/*
  {
    path: '',
    redirectTo: '/main/(outlet-home:main)',
    // component: TabsPage,
    pathMatch: 'full'
  }
  */
    // { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    // { path: '', loadChildren: './pages/home/home.module#HomePageModule', pathMatch: 'full'}
/*
    ,
    { path: 'market', loadChildren: './pages/market/market.module#MarketPageModule'},
    { path: 'fight', loadChildren: './pages/fight/fight.module#FightPageModule'},
    { path: 'bbs', loadChildren: './pages/bbs/bbs.module#BbsModule'},
    { path: 'mypage', loadChildren: './pages/mypage/main.module#MyPageMainModule'},
    { path: 'mypage/games', loadChildren: './pages/mypage/games/main.module#MyGamePageModule'},
    { path: 'mypage/note', loadChildren: './pages/mypage/note/note.module#NotePageModule'},
    { path: 'mypage/pattern', loadChildren: './pages/mypage/pattern/pattern.module#PatternModule'},
    */

];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
/*import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
*/
